<template>
  <span v-if="session?.foreigner" class="badge bg-info-soft"
    ><i class="fa-solid fa-clock me-1"></i>
    <span v-if="icon">
      {{ languages["pt-br"].flag }}
    </span>
    <span v-else>Horário de Brasília</span>
  </span>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useSessionStore } from "@/store/useSessionStore";
import { languages } from "../utils/languages";

// ?.: a sessão fica nula por um instante ao sair, com a tela ainda montada
const { session } = storeToRefs(useSessionStore());

const { icon } = defineProps<{ icon?: boolean }>();
</script>
